import * as API from './actionTypes';
import service from '../services/index';
import _, { sortBy } from 'lodash';

/*
		----------------------------------------------------------------
					Login, Signin of User, Workspace Action				
		----------------------------------------------------------------
*/

export const verifyLoginWithPassword = async (payload) => {
	return await service.fetchPost(
		API.TENANT_USER_LOGIN_SIGNUP_API.loginWithPassword,
		payload,
		null,
		'tenant-users',
	);
};
export const get2FAStatus = async (email) => {
	return await service.fetchGet(
		API.TENANT_USER_LOGIN_SIGNUP_API.get2FAStatus + `?email=${email}`,
		null,
		'tenant-users',
	);
};
export const userDetails = async (usertoken) => {
	return await service.fetchGet(API.TENANTS.myProfile, usertoken, 'tenant-users');
};
export const getTenantSettings = async (tenantID, token) => {
	return await service.fetchGet('/' + tenantID, token, 'tenant');
};
export const uploadProfilePicture = async (employeeId, token) => {
	return await service.fetchGet(
		`${API.TENANTS.employee}/${employeeId}${API.TENANTS.profilePicture}`,
		token,
		'tenant-users',
	);
};
